/*
 Created by CHT 2019/12/5 10:23
 富媒体图表（富媒体控件）
*/
import BaseChart from "../BaseChart"
import {CHART_CATEGORY__MEDIA, CHART_TYPE__MEDIA_CHART} from "../types"

class MediaChart extends BaseChart{
  constructor() {
    super()

    this.w = 18
    this.h = 10
  }

  get title() {
    return this.chartName || MediaChart._title
  }

  set title(content) {
    this.chartName = content
  }
}

MediaChart._title = '富媒体图表'
MediaChart.type = CHART_TYPE__MEDIA_CHART

MediaChart.prototype.chartCategory = CHART_CATEGORY__MEDIA
MediaChart.prototype.chartType = MediaChart.type

export default MediaChart
